import { gql } from '@apollo/client'

const SUBSCRIPTION_UNSUSPENSION_ATTEMPT_MUTATION = gql`
  mutation SubscriptionUnsuspensionAttemptMutation {
    subscriptionUnsuspensionAttempt {
      id
    }
  }
`

export { SUBSCRIPTION_UNSUSPENSION_ATTEMPT_MUTATION }
